import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { PagedDataProvider } from '@shared/models/data-provider.model';
import { cardsTransitions } from '@shared/transitions/router.transitions';
import { merge, of, Subject, Subscription } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-paged-cards',
  templateUrl: './paged-cards.component.html',
  styleUrls: ['./paged-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [cardsTransitions]
})
export class PagedCardsComponent<P extends PagedDataProvider<D>, D> implements OnInit, OnDestroy {

  @Input()
  public provider: P;

  @Input()
  public dataSource: Subject<Map<string, D>> = new Subject();

  @Input()
  public responseKey: string;

  @Input()
  public mapKey: string;

  @ViewChild(MatPaginator, { static: true })
  public paginator: MatPaginator;

  @ContentChild(TemplateRef, { static: true })
  public pagedCardTemplate;

  public resultsLength = 0;

  private data$: Subscription;

  constructor(private cd: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.paginator.pageSize = this.provider.page.pageSize;

    this.data$ = merge(this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.provider.loadingState = true;
          this.provider.page.currentIndex = this.paginator.pageIndex;

          return this.provider.loadData();
        }),
        map(data => {
          this.provider.loadingState = false;
          // TODO not available
          // this.resultsLength = (<any>data).meta.total;

          return data;
        }),
        catchError(() => {
          this.provider.loadingState = false;
          return of([]);
        })
      )
      .subscribe(data => {
        const dataMap = new Map();
        const dataArr = data[this.responseKey];
        if (Array.isArray(dataArr) && dataArr.length > 0) {
          for (const item of (dataArr as D[])) {
            dataMap.set(item[this.mapKey], item);
          }
        }
        this.dataSource.next(dataMap);
        this.cd.markForCheck();
      });
  }

  ngOnDestroy() {
    this.data$.unsubscribe();
    this.dataSource.unsubscribe();
  }

}
